export class FileManager {
  constructor(storage, pipeService, req, appProcessor) {
    this.storage = storage;
    this.pipeService = pipeService;
    this.req = req;
    this.appProcessor = appProcessor;
  }

  //********************* UPLOAD FILE *********************//

  async uploadFileApi(fileData, app_id, item_id) {
    try {
      const form = {
        "file-0": fileData,
        app_id,
        item_id,
      };
      const file = await this.req.post({
        url: "/file/formupload",
        form,
      });
      return file;
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  async uploadFileFromStringApi(fileObject) {
    try {
      const file = await this.req.post({
        url: "/file/upload",
        form: { file: JSON.stringify(fileObject) },
      });
      return file;
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  async updateFileFromStringApi(data, file_id, file_name, extension, format, alt, title) {
    try {
      const fileObj = {
        file_name,
        extension,
        file_id,
        format,
        source: data,
        alt,
        title
      };

      const file = await this.req.post({
        url: "/file/update",
        form: { file: JSON.stringify(fileObj) },
      });
      return file;
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  async duplicateFileApi(files) {
    return this.req.post({
      url: "/api/new/file/duplicate",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      form: {
        files: JSON.stringify(files),
      },
    });
  }

  async downloadFileFromString(app_id, file_id) {
    if(await this.isFileExists(app_id, file_id)) {
      let file = await this.getFile(app_id, file_id);
      let data = await this.req.get({
        url: file.url + '?timestamp=' + file.last_update,
        externalResource: true
      });
      return {
        file,
        data,
        type: 'file'
      }
    } else {
      return false;
    }
  }

  async duplicateFile(files) {
    let duplicatedFiles = await this.duplicateFileApi(files);
    duplicatedFiles.forEach(file => {
      this.addFileToStorage(file.app_id, file);
    });
    return duplicatedFiles;
  }

  async deleteFileApi(id) {
    try {
      const file = await this.req.get({
        url: `/file/delete?file_id=${id}`,
      });
      return file;
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  addFileToStorage(app_id, file) {
    const app = this.storage.getApp(app_id);
    if (app) {
      app.file_list.push(file);
      this.storage.updateApp(app);
      this.pipeService.emit("gh_file_upload", { app_id, item_id: file.item_id, file_id: file.file_id }, file);
    }
  }

  addFilesToStorage(app_id, files) {
    const app = this.storage.getApp(app_id);
    if (app) {
      app.file_list.push(...files);
      this.storage.updateApp(app);
      files.forEach(file => {
        this.pipeService.emit("gh_file_upload", { app_id, item_id: file.item_id, file_id: file.file_id }, file);
      });
    }
  }

  deleteFileFromStorage(fileId, app_id) {
    const app = this.storage.getApp(app_id);
    if (app) {
      let deletedFile;
      app.file_list = app.file_list.filter((file) =>  {
        if(file.file_id != fileId) {
          return true;
        } else {
          deletedFile = file;
          return false;
        }
      });
      this.storage.updateApp(app);
      this.pipeService.emit("gh_file_delete", { file_id: fileId }, deletedFile);
    }
  }

  updateFileInStorage(fileId, app_id, newFile) {
    const app = this.storage.getApp(app_id);
    if (app) {
      app.file_list = app.file_list.map((file) =>
        file.file_id == fileId ? newFile : file
      );
      this.storage.updateApp(app);
      this.pipeService.emit("gh_file_update", { file_id: fileId });
    }
  }

  async getFile(app_id, file_id) {
    const app = await this.appProcessor.getApp(app_id);
    return new Promise((resolve,reject) => {
      let findedFile = app.file_list.find((file) => {
        return file.file_id == file_id
      });
      if(findedFile) {
        resolve(findedFile)
      } else {
        resolve('')
      }
    })
}

async getFiles(app_id, filesId = []) {
  
    const app = await this.appProcessor.getApp(app_id);
    return new Promise((resolve, reject) => {
      let findedFiles = app.file_list.filter((file) => {
        return filesId.some(id => {
          return id == file.file_id;
        })
      });
      if(findedFiles) {
        resolve(findedFiles);
      } else {
        resolve('')
      }
    })
}

  async uploadFile(fileData, app_id, item_id) {
    const file = await this.uploadFileApi(fileData, app_id, item_id);
    this.addFileToStorage(app_id, file);
    return file;
  }

  async uploadFileFromString(fileObject) {
    const file = await this.uploadFileFromStringApi(fileObject);
    this.addFileToStorage(file.app_id, file);
    return file;
  }

  async updateFileFromString(data, file_id, file_name, extension, format, alt, title) {
    const file = await this.updateFileFromStringApi(
      data,
      file_id,
      file_name,
      extension,
      format,
      alt,
      title
    );
    this.updateFileInStorage(file_id, file.app_id, file);
    return file;
  }

  async deleteFile(id, app_id) {
    await this.deleteFileApi(id);
    this.deleteFileFromStorage(id, app_id);
    return true;
  }

  async isFileExists(app_id, file_id) {
    let urlPattern = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
    if(Boolean(file_id)) {
      let file = await this.getFile(app_id, file_id);
      if(Boolean(file)) {
        return urlPattern.test(file.url);
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
